export default "__VITE_ASSET__0893c5f9__"